import { render, staticRenderFns } from "./HotelFeatures.vue?vue&type=template&id=fde6b8a2&scoped=true&"
import script from "./HotelFeatures.vue?vue&type=script&lang=js&"
export * from "./HotelFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde6b8a2",
  null
  
)

export default component.exports